import * as React from 'react';
import * as $ from 'jquery';
import * as _ from 'underscore';

require('../sass/nav-tabs-scrollable.sass');

export interface INavTabScrollableProperties {
    content: any;
    workspaceNames?: string;
    onMount?(maxWidth: number): void;
}

interface INavTabScrollableState {
    showScrollerRight: boolean;
    showScrollerLeft: boolean;
    left: number;
    curPosition: number;
    itemHeight: number;
    minWidth: number;
    maxWidth: number;
}

function calculateGeometry(navList: HTMLUListElement) {
    const items = navList.children;

    let itemHeight = 0;
    let maxItemWidth = 0;
    let totalItemWidth = 0;

    if (items.length > 0) {
        itemHeight = items[0].clientHeight;

        _.each(items, (item) => {
            const itemWidth = item.clientWidth;

            //LL: 10.12.21: try - ok, but here w=itemWidth
            //let w = window.getComputedStyle(item, null).getPropertyValue("width");
            totalItemWidth += itemWidth + 6;

            if (maxItemWidth < itemWidth) {
                maxItemWidth = itemWidth;
            }
        });
    }

    return {
        itemHeight: itemHeight,
        maxItemWidth: maxItemWidth,
        totalItemsWidth: totalItemWidth
    };
}

export default class NavTabScrollable extends React.Component<INavTabScrollableProperties, INavTabScrollableState> {
    private references: {
        wrapper?: HTMLDivElement;
        navList?: HTMLUListElement;
    } = {};

    private itemPositions: number[] = [];

    constructor(props) {
        super(props);

        this.state = {
            showScrollerRight: false,
            showScrollerLeft: false,
            left: 0,
            curPosition: 0,
            itemHeight: 0,
            minWidth: 0,
            maxWidth: 0
        };
    }

    componentDidMount() {
        const itemSizes = calculateGeometry(this.references.navList);

        this.setState({
            maxWidth: itemSizes.totalItemsWidth,
            minWidth: itemSizes.maxItemWidth
        });

        // See Issue 99692.
        if (itemSizes.itemHeight > 0) {
            this.setState({
                itemHeight: itemSizes.itemHeight
            });
        }

        this.reAdjust();

        if (this.props.onMount != null) {
            this.props.onMount(itemSizes.totalItemsWidth + 16);
        }

        $(window).on('resize', this.handleWindowResize);
    }

    componentWillUnmount() {
        $(window).off('resize', this.handleWindowResize);
    }

    componentDidUpdate() {
        const itemSizes = calculateGeometry(this.references.navList);

        this.setState({
            maxWidth: itemSizes.totalItemsWidth,
            minWidth: itemSizes.maxItemWidth
        });

        // See Issue 99692.
        if (itemSizes.itemHeight > 0) {
            this.setState({
                itemHeight: itemSizes.itemHeight
            });
        }

        this.reAdjust();

        if (this.props.onMount != null) {
            this.props.onMount(itemSizes.totalItemsWidth + 16);
        }
    }

    shouldComponentUpdate(nextProps: INavTabScrollableProperties, nextState: INavTabScrollableState) {
        return (
            nextState.showScrollerRight !== this.state.showScrollerRight ||
            nextState.showScrollerLeft !== this.state.showScrollerLeft ||
            nextState.left !== this.state.left ||
            nextState.itemHeight !== this.state.itemHeight ||
            nextState.minWidth !== this.state.minWidth ||
            nextState.maxWidth !== this.state.maxWidth ||
            !_.isEqual(nextProps.content, this.props.content) ||
            !_.isEqual(nextProps.workspaceNames, this.props.workspaceNames)
        );
    }

    handleWindowResize = () => {
        this.reAdjust();
    };

    widthOfList = () => {
        const items = this.references.navList.children;
        const marginWidth = 28;
        const wrapperWidth = $(this.references.wrapper).innerWidth() - marginWidth;

        let itemsWidth = 0;

        this.itemPositions = [0];

        _.each(items, (item) => {
            const itemWidth = item.clientWidth;

            itemsWidth += itemWidth;

            if (itemsWidth > wrapperWidth) {
                this.itemPositions.push(itemsWidth - wrapperWidth);
            }
        });

        return itemsWidth;
    };

    // Used to check whether to show either arrow
    reAdjust = () => {
        if (this.references.wrapper == null) {
            return;
        }

        const wrapperWidth = this.references.wrapper.clientWidth;
        const widthOfList = this.widthOfList();
        const leftPos = this.references.navList.clientLeft;

        if (wrapperWidth < widthOfList) {
            this.setState({
                showScrollerRight: true
            });
        } else {
            this.setState({
                showScrollerRight: false
            });
        }

        if (leftPos < 0) {
            this.setState({
                showScrollerLeft: true
            });
        } else {
            this.setState({
                showScrollerLeft: false
            });
        }
    };

    handleMoveLeft = () => {
        if (this.state.curPosition - 1 >= 0) {
            const newPos = this.state.curPosition - 1;

            this.setState({
                left: 0 - this.itemPositions[newPos],
                curPosition: newPos
            });
            //this.reAdjust();
        }
    };

    handleMoveRight = () => {
        if (this.state.curPosition + 1 < this.itemPositions.length) {
            const newPos = this.state.curPosition + 1;

            this.setState({
                left: 0 - this.itemPositions[newPos],
                curPosition: newPos
            });
            //this.reAdjust();
        }
    };

    render() {
        const navStyle: React.CSSProperties = {
            left: this.state.left.toString() + 'px'
        };

        let marginBottom = '-0.45rem';

        // if (this.state.itemHeight > 35) {
        //     marginBottom = '-0.48rem';
        // }

        const itemHeight = this.state.itemHeight;
        const wrapperStyle: React.CSSProperties = {
            //maxWidth: this.state.maxWidth + 'px',
            minWidth: this.state.minWidth + 'px',
            height: itemHeight + 'px',
            marginBottom: marginBottom
            //marginBottom: '-' + (this.state.itemHeight - 29.8).toString() + 'px'
        };

        let hiddenScrollerClass = '';

        if (this.state.showScrollerLeft === false && this.state.showScrollerRight === false) {
            hiddenScrollerClass = 'hidden';
        }

        return (
            <div className="navtab-scrollable d-flex align-items-center flex-nowrap">
                <div
                    className="wrapper flex-grow-1"
                    ref={(value) => {
                        this.references.wrapper = value;
                    }}
                    style={wrapperStyle}
                >
                    <ul
                        className="nav nav-tabs navtabs-list"
                        ref={(value) => {
                            this.references.navList = value;
                        }}
                        style={navStyle}
                    >
                        {this.props.content}
                    </ul>
                </div>
                <div
                    className={'border-left shadow scroller ' + hiddenScrollerClass}
                    style={{ height: itemHeight * 0.8 + 'px' }}
                ></div>
                <div
                    className={'scroller ' + hiddenScrollerClass + (this.state.showScrollerLeft ? '' : ' disabled')}
                    onClick={this.handleMoveLeft}
                >
                    <span className="h-100 glyphicon glyphicon-chevron-left"></span>
                </div>
                <div
                    className={'scroller ' + hiddenScrollerClass + (this.state.showScrollerRight ? '' : ' disabled')}
                    onClick={this.handleMoveRight}
                >
                    <span className="h-100 glyphicon glyphicon-chevron-right"></span>
                </div>
            </div>
        );
    }
}
